import { render } from "./NewRoleForm.vue?vue&type=template&id=797f6d5d&scoped=true"
import script from "./NewRoleForm.vue?vue&type=script&lang=js"
export * from "./NewRoleForm.vue?vue&type=script&lang=js"

import "./NewRoleForm.vue?vue&type=style&index=0&id=797f6d5d&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797f6d5d"]])

export default __exports__